import Media from './../mediaDetect.js'; //Детектор медиа
import Scrollbar from './scrollbar.js';
import Search from './search.js';

var currCloseSidenav = '',
    currScrollSidenav;

let Sidenav = {
    Menu: {
        open: function(menuSidenav){
            let _body = $('body'),
                headerFixed = $('[data-header-content]');

            if (!_body.hasClass('sidenav-menu-opened')){
                if(Scrollbar.isActive()){
                    let widthScrollbar = Scrollbar.getWidth();

                    _body.css('padding-right', widthScrollbar + 'px');
                    headerFixed.css('padding-right', widthScrollbar + 'px');
                    menuSidenav.css('right', widthScrollbar + 'px');
                }

                _body.addClass('sidenav-menu-opened');

                // Запоминаем текущую позицию скролла
                currScrollSidenav = $(window).scrollTop();
                // Класс для фиксирование шапки и скрытия поздравления ген.директора
                _body.addClass('fixed-header-open-sidenav');
                // Устанавливаем высоту sidenav и после открытия скрываем контент
                menuSidenav.animate({height: $(window).outerHeight()}, 300, function(){
                    _body.addClass('hide-content-open-sidenav');
                });
            }
        },
        close: function(menuSidenav, openSearch){
            let _body = $('body'),
                headerFixed = $('[data-header-content]');

            // Убираем блокировку высоты контента
            _body.removeClass('hide-content-open-sidenav');
            // Проматываем страницу на позицию, которую запомнили
            $(window).scrollTop(currScrollSidenav);

            menuSidenav.animate({height: '0px'}, 300,
                function(){

                    let itemMenu = $('[data-item-menu-sidenav]');
                    if(itemMenu.length){
                        itemMenu.each(function( index ) {
                            $(this).removeAttr('style').removeClass('active');
                        });
                    }
                    
                    Sidenav.SubSubmenu.clear();

                    headerFixed.removeAttr('style');
                    menuSidenav.css('right', '').removeAttr('style');

                    if(!Search.isOpen()) {
                        _body.removeClass('sidenav-menu-opened').removeAttr('style');
                    }

                    if(openSearch) {
                        Search.open();
                    }else{
                        // Убираем фиксирование шапки и отображаем поздравление ген.директора
                        _body.removeClass('fixed-header-open-sidenav');
                    }
                }
            );
        },
        toggle: function(menuSidenav){
            if ($('body').hasClass('sidenav-menu-opened')){
                Sidenav.Menu.close(menuSidenav);
            } else {
                Sidenav.Menu.open(menuSidenav);
            }
        },
        isOpen: function(){
            return $('body').hasClass('sidenav-menu-opened');
        }
    },
    Submenu: {
        open: function(itemMenu, allItems){
            allItems.slideUp(400, function(){
                itemMenu.addClass('active').slideDown();
            });
        },
        close: function(itemMenu, allItems){
            itemMenu.slideUp(400, function(){
                itemMenu.removeClass('active');
                allItems.slideDown();
            });
        }
    },
    SubSubmenu: {
        open: function(currItemSubmenu){
            let currItemMenu = currItemSubmenu.closest('[data-item-menu-sidenav]');

            // Сворачиваем текущий пункт меню
            currItemMenu.slideUp(400, function(){

                // После завершения анимации скрываем все подпункты текущего пункта меню
                currItemMenu.find('[data-item-submenu-menu-sidenav]').hide(0);

                currItemMenu.addClass('open-sub-submenu').removeAttr('style');

                // Текущему подпункту добавляем класс и разворачиваем его
                currItemSubmenu.addClass('active').slideDown();
            });
        },
        close: function(currItemSubmenu){
            let currItemMenu = currItemSubmenu.closest('[data-item-menu-sidenav]');

            // Сворачиваем текущий подпункт меню
            currItemSubmenu.slideUp(400, function(){

                // Убираем активность у текущего подпункта меню
                currItemSubmenu.removeClass('active');

                // Убираем стили у всех подпунктов
                currItemMenu.find('[data-item-submenu-menu-sidenav]').removeAttr('style');

                // Скрываем все пункты меню, кроме родителя текущего подпункта (т.е. отображаем 2-ой уровень меню)
                currItemMenu.closest('[data-list-menu-sidenav]').find('[data-item-menu-sidenav]').hide(0);
                currItemMenu.removeClass('open-sub-submenu').slideDown();
            });
        },
        clear: function(){
            let btnCloseSubSubmenu = $('[data-btn-sub-submenu-menu-sidenav]');
            if(btnCloseSubSubmenu.length) {
                $('[data-item-submenu-menu-sidenav]').each(function( index ) {
                    var _this = $(this);

                    if(_this.hasClass('active')){
                        _this.closest('[data-item-menu-sidenav]').removeClass('open-sub-submenu');
                    }
                    _this.removeAttr('style').removeClass('active');
                });               
            }
        }
    }
}

$(document).ready(function($) {
    // Пересчитываем высоту для sidenav
    $(window).resize(function() {
        if((Media.detect().isTablet || Media.detect().isMobile) && Sidenav.Menu.isOpen()){
            $('[data-sidenav-menu]').stop().outerHeight($(window).outerHeight());
        } 
    });

    // sidenav panel
    let sidenav = $('[data-sidenav]');
    if (sidenav.length){
        $('[data-btn-toggle-menu-sidenav]').on('click', function(){

            if(Search.isOpen()) {
                Search.close(true);
            }else{
                Sidenav.Menu.toggle($('[data-sidenav-menu]'));
            }
        });
    }
    // /sidenav panel

    // Подменю
    let btnSubmenu = $('[data-btn-submenu-menu-sidenav]');
    if(btnSubmenu.length) {
        btnSubmenu.on('click', function(e){
            let _this = $(this),
                item = _this.closest('[data-item-menu-sidenav]'),
                allItems = _this.closest('[data-list-menu-sidenav]').find('[data-item-menu-sidenav]');

            if(item.hasClass('active')) {
                if(_this.data('btn-submenu-menu-sidenav') != 'link'){
                    Sidenav.Submenu.close(item, allItems);
                }
            }else{
                e.preventDefault();
                Sidenav.Submenu.open(item, allItems);
            }
        });
    }
    // End подменю

    // Подменю второго уровня
    let btnSubSubmenu = $('[data-btn-sub-submenu-menu-sidenav]');
    if(btnSubSubmenu.length) {
        btnSubSubmenu.on('click', function(e){
            if(Media.detect().isTablet){

                let _this = $(this),
                    item = _this.closest('[data-item-submenu-menu-sidenav]');

                if(item.hasClass('active')) {
                    if(_this.data('btn-sub-submenu-menu-sidenav') != 'link'){
                        Sidenav.SubSubmenu.close(item);
                    }
                }else{
                    e.preventDefault();
                    Sidenav.SubSubmenu.open(item);
                }
            }
        });
    }
    // End второго уровня

    // обрабатываем изменение точки остановки или старт страницы
    $(window).on('mdbreakpoint', function(e, breakpointOld, breakpointOldNew) {

        if((breakpointOld == 'isTablet' || breakpointOld == 'isMobile')&&
            (breakpointOldNew == 'isDesktop' || breakpointOldNew == 'isDesktopHD')) {

            Sidenav.Menu.close($('[data-sidenav-menu]'));
        }

        // При переходе с мобилки на планшет переходим на текущий пункт меню второго уровня (закрывая третий уровень)
        if((breakpointOld == 'isMobile')&&(breakpointOldNew == 'isTablet')) {
            Sidenav.SubSubmenu.clear();
        }
    });
});

export default {
    openMenu: Sidenav.Menu.open,
    closeMenu: Sidenav.Menu.close,
    isOpenMenu: Sidenav.Menu.isOpen
};


// WEBPACK FOOTER //
// ./components/sidenav.js